import Logo from "./Logo";
import Nav from "./Nav";

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 mx-auto flex w-full max-w-11xl items-start md:items-center justify-between border-b border-gray-100 bg-background px-6 py-3 font-sans font-bold uppercase text-text-primary backdrop-blur-[100px] flex-wrap">
      <Logo />
      <Nav />
    </header>
  );
};

export default Header;
